import { ReactComponent as GoplusLogo } from '../assets/goplus.svg';

export const SnapLogo = () => (
  // <img width={size} src={logo} alt="logo" />
  <GoplusLogo />
);
